module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    staticClass: "addPromoCode",
    attrs: {
      "name": "addPromoCode",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "80%",
      "maxWidth": "500"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('h3', [_vm._v("Add Promo Code")]), _vm._v(" "), (_vm.invalidError) ? _c('div', {
    staticClass: "errorMsg"
  }, [_vm._v(_vm._s(_vm.invalidMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-data-outer"
  }, [_c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Promo Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promoCodeData.code),
      expression: "promoCodeData.code"
    }],
    domProps: {
      "value": (_vm.promoCodeData.code)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promoCodeData, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Total Times Used ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promoCodeData.totalTimesUsed),
      expression: "promoCodeData.totalTimesUsed"
    }],
    domProps: {
      "value": (_vm.promoCodeData.totalTimesUsed)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promoCodeData, "totalTimesUsed", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Usage Limit ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promoCodeData.usageLimit),
      expression: "promoCodeData.usageLimit"
    }],
    domProps: {
      "value": (_vm.promoCodeData.usageLimit)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promoCodeData, "usageLimit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("ExpirationDate")]), _vm._v(" "), _c('date-time-field', {
    attrs: {
      "name": "date",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "date"
    },
    model: {
      value: (_vm.promoCodeData.expirationDate),
      callback: function($$v) {
        _vm.$set(_vm.promoCodeData, "expirationDate", $$v)
      },
      expression: "promoCodeData.expirationDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-data my-tag-field"
  }, [_c('label', [_vm._v("Tag")]), _vm._v(" "), _c('selectize', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "options": _vm.tagsOptions,
      "multiple": "",
      "size": "1",
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "isRunnerTag": false,
      "isRaceTag": false,
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    on: {
      "click": function($event) {
        return _vm.Save()
      }
    }
  }, [_vm._v("Save")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38401080"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/PromoCodeManager/AddPromoCode.vue
// module id = 1655
// module chunks = 2